import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { IApplicationState } from '../../types/redux';

export const selectJsonQuery = (state: IApplicationState): IJsonQuery => {
  return state.jsonQuery;
};
